if(!customElements.get('hero-banners')) {
  customElements.define(
    'hero-banners',
    class HeroBanners extends HTMLElement {
      #sliderEl = undefined;
      #sliderInstance = undefined;
      #sliderPrevEl = undefined;
      #sliderNextEl = undefined;
      #sliderPaginationEl = undefined;

      constructor() {
        super();
      }

      connectedCallback() {
        this.#sliderEl = this.querySelector('[data-slider]');
        this.mount();
      }

      mount() {
        if(!this.#sliderEl) {
          return console.error('[Slider] No slider element was found.')
        }

        this.#sliderInstance = new Swiper(this.#sliderEl, {
          loop: true,
          effect: "fade",
          autoplay: {
            delay: 6000,
            disableOnInteraction: false,
          },
          slidesPerView: 1,
          spaceBetween: 0,
        });
      }

      get slider() {
        return this.#sliderInstance;
      }
    }
  )
}